jQuery(function ($) {

  $(document).ready(function () {

    // Show submenu if submenu page is active
    if( $('.is-submenu-item').hasClass('active') ) {
      $(".accordion-menu").foundation('down',$(".is-accordion-submenu"));
    }
    else {
      // Show on hover
      $(".accordion-menu").hover(function() {
        $(this).foundation('toggle',$(".is-accordion-submenu"));
      });
    }

  });

// End Jquery
});
